var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.05,
    height: 37.1,
    viewBox: "0 0 18.05 37.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.68,24.5h-3.31c-4.06,0-7.37-3.31-7.37-7.37V7.37C0,3.31,3.31,0,7.37,0h3.31c4.06,0,7.37,3.31,7.37,7.37v9.76c0,4.06-3.31,7.37-7.37,7.37ZM7.37.7C3.69.7.7,3.69.7,7.37v9.76c0,3.68,2.99,6.67,6.67,6.67h3.31c3.68,0,6.67-2.99,6.67-6.67V7.37c0-3.68-2.99-6.67-6.67-6.67h-3.31Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.68,
    y: 27.61,
    width: 0.7,
    height: 8.73,
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.9 34.01 11.38 33.53 9.03 36.07 6.67 33.53 6.16 34.01 9.03 37.1 11.9 34.01",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.68,
    y: 4.11,
    width: 0.7,
    height: 6.94,
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoDown);
export default __webpack_public_path__ + "static/media/go-down.1bf7d4b1f871ed96835af5248b9d1fed.svg";
export { ForwardRef as ReactComponent };